import { BarChart } from "@mui/x-charts/BarChart";

const RenderStyleCountBarGraph = ({ dataArr, xAxis, ...rest }) => {
	return (
		<BarChart
			series={dataArr ?? [{ data: [35, 44, 24, 34] }, { data: [51, 6, 49, 30] }]}
			xAxis={xAxis ?? [{ data: ["Q1", "Q2"], scaleType: "band", categoryGapRatio: 0.5, barGapRatio: 0.3 }]}
			margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
			slotProps={{ legend: { hidden: true } }}
			{...rest}
		/>
	);
};

export default RenderStyleCountBarGraph;
